export default "__VITE_ASSET__DzUZTfUW__"